import React, { useState } from 'react';
import { Link } from 'react-router-dom';


import logo from '../img/logo.png'


import '../css/navbar.css'

const Navbar = () => {
    const [expanded, setExpanded] = useState(false);

    const handleNavItemClick = () => {
        setExpanded(false);
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/" onClick={handleNavItemClick}> 
                    {/* SHANTI FERTILIZER */}

<img src={logo}/>
               
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded={expanded ? "true" : "false"}
                        aria-label="Toggle navigation"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleNavItemClick}>Home</Link>
                            </li>





                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="appointmentDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    About Us 
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="appointmentDropdown">
                                    <li><Link className="dropdown-item" to="/About" onClick={handleNavItemClick}>About Company </Link></li>
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}>About Owner </Link></li>
                                </ul>
                            </li>




                          
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="supportDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                  Our Categorey
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li>
                                        <Link className="dropdown-item" to="/Fertilize" onClick={handleNavItemClick}>
                                           Our Dealership
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/Distrubion" onClick={handleNavItemClick}>
                                            Our Distributorship 
                                        </Link>
                                    </li>
                                   
                                    
                                </ul>
                            </li>



                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="managementDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                  Products
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="managementDropdown">
                                    <li>
                                        <Link className="dropdown-item" to="/Services" onClick={handleNavItemClick}>
                                            Products
                                        </Link>
                                    </li>
                                   
                                </ul>
                            </li>


                            <li className="nav-item">
                                <Link className="nav-link" to="/Gallery" onClick={handleNavItemClick}>Gallery</Link>
                            </li>


                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleNavItemClick}>Faq's</Link>
                            </li>


                            <li className="nav-item">
                                <Link className="nav-link" to="/Contact" onClick={handleNavItemClick}>Contact</Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
